import { useTranslation } from 'react-i18next';
import type { InvalidItemsError } from '../../shared/BulkAdd/types.ts';
import { normalizeDomain } from '../utils/normalizeDomain.ts';
import { useValidateDomain } from './useValidateDomain.ts';

type ValidationResult = {
  errors: InvalidItemsError[];
  validItems: string[];
};

export const useValidate = () => {
  const { t } = useTranslation();
  const validateDomain = useValidateDomain();

  return (items: string[], inventoryListValues: string[] = []): ValidationResult => {
    const added = new Set();
    const inventoryList = new Set(inventoryListValues.map(normalizeDomain));

    const duplicates: string[] = [];
    const invalid: string[] = [];
    const validItems: string[] = [];

    for (const rawDomain of items) {
      const normalized = normalizeDomain(rawDomain);
      const errorMsg = validateDomain(rawDomain);

      if (errorMsg) {
        invalid.push(rawDomain);
        continue;
      }

      if (added.has(normalized) || inventoryList.has(normalized)) {
        duplicates.push(rawDomain);
      } else {
        validItems.push(normalized);
        added.add(normalized);
      }
    }

    const errors: InvalidItemsError[] = [];

    if (duplicates.length) errors.push({ error: t('Duplicates.'), invalidItems: [...new Set(duplicates)] });

    if (invalid.length) errors.push({ error: t('Invalid Domains.'), invalidItems: [...new Set(invalid)] });

    return { errors, validItems };
  };
};
